export default "__VITE_ASSET__92MI0$76__"